import gql from 'graphql-tag';

export const getTenantChannelsByOrgs = gql`
  query getTenantChannelsByOrgs($orgIds: [UUID!]!) {
    tenantChannelsByOrgsForUser(orgIds: $orgIds) {
      items {
        tenantChannelId
        propertyChannelId
        name
      }
    }
  }
`;
